const emailPreferenceCenter = [
    {
        selector: '[data-form-name=other_email_preference_center]',
        path: { filename: 'populateFormWithUserInfo' },
    },
    {
        selector: '[data-email-unsubscribe]',
        path: { filename: 'unsubscribe' },
    },
];

export { emailPreferenceCenter };
